import { render, staticRenderFns } from "./TxnFailed.vue?vue&type=template&id=5e2d3fca&scoped=true&"
import script from "./TxnFailed.vue?vue&type=script&lang=js&"
export * from "./TxnFailed.vue?vue&type=script&lang=js&"
import style0 from "./TxnFailed.vue?vue&type=style&index=0&id=5e2d3fca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2d3fca",
  null
  
)

export default component.exports